import _ from 'lodash';
import moment from 'moment';
import { pushNotification } from '../../apis/firebase';
import { ALLSHOP, ERROR_PUSH_NOTIFICATION, ERROR_WRONG_INFORMATIONS } from '../../constants';
import { isStringNotNull } from '../../utils/tools';
import { sendCloudWatchAlert } from '../../utils/applicationError';

export const handleClick = setStateObj =>
  setStateObj({
    modalOpen: true,
    title: '',
    message: ''
  });

export const handleClose = setStateObj =>
  setStateObj({
    modalOpen: false,
    message: '',
    title: '',
    isLoadingModal: false,
    toAllUsers: false
  });


export const initPushNotification = async (shopId, clients, devices, pushNotification, setStateObj) => {
  const users = [];
  const allUsers = [];
  _.map(clients, (user, userId) => {
    const { shopIds } = user;
    allUsers.push({ id: userId });
    if (shopIds) {
      _.find(shopIds, shop => {
        return shop === shopId || (shop.shopId === shopId && users[users.length - 1] !== userId);
      }) && users.push({ id: userId });
    }
  });
  _.map(devices, (element, index) => {
    allUsers.push({ id: index, isDevice: true });
  });
  setStateObj({
    users,
    allUsers,
    pushNotification
  });
};

export const handleSendNotification = async (setStateObj, title = '', message = '', toAllUsers, isAdminOfOneShop, users, allUsers, shopId, openErrorModal) => {
  setStateObj({ isLoadingModal: true });
  if (isStringNotNull(message) && isStringNotNull(title)) {
    try {
      pushNotification({
        title,
        message,
        date: moment().format(),
        users: toAllUsers || isAdminOfOneShop ? allUsers : users,
        cible: toAllUsers ? ALLSHOP : shopId
      });
      handleClose(setStateObj)
    } catch (error) {
      sendCloudWatchAlert(`Error sending push notification: ${error}`);
      openErrorModal(ERROR_PUSH_NOTIFICATION);
    }
  } else {
    openErrorModal(ERROR_WRONG_INFORMATIONS);
    setStateObj({ isLoadingModal: false });
  }
};

export const handleChange = async (event, setStateObj) => {
  setStateObj({ [event.target.id]: event.target.checked });
};
